export const columnFields = [
	'integration.iCommand.status',
	//
	'organization.name',
	'client.name',
	//
	'jobName',
	'jobRef',
	'transactionName',
	'transactionRef',
	//
	'builder.name',
	'project.name',
	'customer.name',
	//
	'jobType.name',
	'requestType.name',
	'requirements.name',
	//
	'createdAt',
	'targetAt',
	'dueAt',
	'designEndedAt',
	//
	'difficultyRating',
	//
	'team.salesPerson.name',
	'team.owner.name',
	//
	'stage.name',
	'status.name',
	'assignedTo.name',
	'timeInStatus',
	//
	'unreadMessages',
] as const;
